<template>
	<div class="animated fadeIn">
		<b-tabs v-model="activeTab">
			<b-tab title="Основная Информация" @click="handleTabClick">
				<update-index :id="id"></update-index>
			</b-tab>
			<b-tab title="Загрузка документов" @click="handleTabClick">
				<update-file :id="id"></update-file>
			</b-tab>
		</b-tabs>
	</div>
</template>
<script>
import UpdateIndex from '@/components/product/update/index'
import UpdateFile from '@/components/online/update/file'
export default {
	components: {
		'update-index': UpdateIndex,
		'update-file': UpdateFile
	},
	data () {
		return {
			readyApiData: false,
			id: null,
			activeTab: 0,
			tabs: {
				0: 'view',
				1: 'members'
			},
			data: {}
		}
	},
	created () {
		this.id = parseInt(this.$route.params.id)
	},
	methods: {
		handleTabClick (tab, event) {
			// this.$router.push({path: '/events/' + this.id + '/' + this.tabs[this.activeTab]})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/product/updateTabs/index.vue